import { layoutImage } from "../../../layout/image.js";
import "@universityofmaryland/web-builder-library";
import "@universityofmaryland/web-styles-library";
import "@universityofmaryland/web-token-library";
const ELEMENT_MEDIA_INLINE_CONTAINER = "element-media-inline-container";
const STYLES_MEDIA_INLINE_ELEMENT = `
  .${ELEMENT_MEDIA_INLINE_CONTAINER} {
    display: block;
    max-width: 100%;
  }

  ${layoutImage.Styles}
`;
const CreateMediaInline = (props) => (() => {
  const elementContainer = document.createElement("div");
  const { image } = props;
  if (image) {
    elementContainer.appendChild(
      layoutImage.CreateElement({
        image,
        showCaption: true
      })
    );
  }
  elementContainer.classList.add(ELEMENT_MEDIA_INLINE_CONTAINER);
  return {
    element: elementContainer,
    styles: STYLES_MEDIA_INLINE_ELEMENT
  };
})();
const createCompositeMediaInlineStandard = CreateMediaInline;
export {
  createCompositeMediaInlineStandard
};
//# sourceMappingURL=standard.js.map
